/** @jsx jsx */
import React, { useCallback } from 'react';
import { jsx } from '@emotion/core';
import { useTheme } from 'emotion-theming';
import { cancelApplication } from 'fmc-sdk';

import { Theme } from 'features/Theme';

import Button from 'components/Button';

import useFmcHost from 'hooks/useFmcHost';
import useQueryParameters from 'hooks/useQueryParameters';
import useOfferMade, { OfferMadeEnum } from 'hooks/requests/offerMade';
import { Status } from 'hooks/requests/fetchUtils';
import useTranslate from 'hooks/useTranslate';

import { ButtonProps } from '@material-ui/core/Button';

/**
 * CancelButton that appears in the embedded case
 * Dispatch cancelApplication to EP
 * Also send an abandoned MadeOffer request for prescreen.
 */

const CancelButton: React.FC<ButtonProps> = props => {
  const fmcDispatch = useFmcHost();
  const theme = useTheme<Theme>();
  const [sendOfferMade, status] = useOfferMade();
  const { prescreenId } = useQueryParameters();
  const t = useTranslate();
  const textToRender = props.children
    ? props.children
    : t('cancelApplicationButton');
  const onClick = useCallback(async () => {
    // TODO: Key off the overrideConfig instead when that is merged.
    if (prescreenId) {
      await sendOfferMade(OfferMadeEnum.Abandoned);
    }
    fmcDispatch(cancelApplication());
  }, [fmcDispatch, sendOfferMade, prescreenId]);

  if (!theme.embedded) {
    return null;
  }

  return (
    <Button
      id="cancel"
      variant="text"
      onClick={onClick}
      loading={status === Status.IN_PROGRESS}
    >
      {textToRender}
    </Button>
  );
};

export default CancelButton;
